import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NominationModule } from '../nomination/nomination.module';
import { AWBSearchModule } from './awb-search/awb-search.module';
import { FlightNumberSearchModule } from './flight-number-search/flight-number-search.module';
import { SearchComponent } from './search.component';

@NgModule({
    imports: [
        CommonModule,
        FlightNumberSearchModule,
        AWBSearchModule,
        MatIconModule,
        MatButtonModule,
        NominationModule,
    ],
    declarations: [SearchComponent],
    exports: [SearchComponent],
})
export class SearchInitModule {}
